export const MEDIA_NODE_TYPES = ["image", "file", "embed", "poll", "video"];
export const MAX_MEDIA_NODE_COUNT = 3;
export const MAX_CHAR_LENGTH = 250;
